import Api from "./Api";

export default {
    check(vatid, country) {
        return Api.get(`check/vatid/${vatid}/${country}`);
    },
    countries() {
        return Api.get(`check/vatid/countries`);
    },
    zipCodes() {
        return Api.get(`check/vatid/zipcodes`);
    },
}